import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {map} from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ApiV1Service {
  // cartlist(params: string) {
  //   throw new Error('Method not implemented.');
  // }
  apiUrl: string = environment.V1_apiUrl;
  RapiUrl: string = environment.V1_RapiUrl;
  R2apiUrl: string = environment.V1_R2apiUrl;
  V2apiUrl: string = environment.V2_apiUrl;
  constructor(private http: HttpClient) { }

  logevent(model) {
      return this.http.post<any>(this.apiUrl + '/other/logevent', model).pipe(
          map(user => {
              
              return user;
          }));
  }

  /** PLUS user activity audit (append-only). Does not affect business APIs. */
  logactivity(model) {
    return this.http.post<any>(this.apiUrl + '/other/logactivity', model).pipe(
      map((res) => res)
    );
  }

  /** Batched activity audit — preferred path from SPA queue. */
  logactivitybatch(activities: any[]) {
    return this.http
      .post<any>(this.apiUrl + '/other/logactivitybatch', { activities })
      .pipe(map((res) => res));
  }

  //Branch Services
  list_branches() {
    return this.http
    .get<any>(this.apiUrl + '/branch/list').pipe(
    map(res => res));
  }

  addeditbranch(branch) {
    console.log(branch);
    return this.http.post(this.apiUrl +'/branch/addeditbranch',branch).pipe(
    map(res => res));
  }

   edit_branch(selectedBranch) {
   console.log(selectedBranch);
    return this.http.put('',selectedBranch).pipe(
    map(res => res));
  }

  //Customer service
  login(username: string, password: string) {
    return this.http.post<any>(this.apiUrl + '/auth1/login', { email: username, password: password }).pipe(
        map(user => {
            // login successful if there's a jwt token in the response
            if (user && user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                localStorage.setItem('token', user.token);
            }
             return user;
        }));
}

  /** Resolve login source: APP only for native Capacitor/Cordova; website defaults to web. */
  getLoginSrc(): string {
    const w = window as any;
    try {
      if (typeof w.Capacitor?.isNativePlatform === 'function' && w.Capacitor.isNativePlatform()) {
        return 'app';
      }
    } catch {
      /* ignore */
    }
    if (w.cordova) {
      return 'app';
    }
    return 'web';
  }

  /** Normalize src: V2D (and unknowns) → web; app/application → app. */
  normalizeLoginSrc(src?: string | null): string {
    const value = String(src || '').trim().toLowerCase();
    if (value === 'app' || value === 'application') {
      return 'app';
    }
    // V2D proxy / empty / anything else from website → web
    return 'web';
  }

  /** V1 login for account switch / session tracking — does not overwrite Directus currentUser. */
  fetchLoginProfile(email: string, password: string, src?: string) {
    const user_agent =
      typeof navigator !== 'undefined' && navigator.userAgent
        ? navigator.userAgent
        : '';
    const resolvedSrc = this.normalizeLoginSrc(src || this.getLoginSrc());
    return this.http.post<any>(this.apiUrl + '/auth1/login', {
      email,
      password,
      src: resolvedSrc,
      appversion: 1,
      user_agent,
    });
  }

  /** Lightweight idle probe — does not write activity; ApiAuth enforces 3h idle. */
  checkSession() {
    return this.http.get<any>(this.apiUrl + '/auth1/checksession');
  }

  /** Close V1 login session for THIS device only (never other devices/apps). */
  logout(
    logout_type: string = 'IDLE_3HR',
    profile?: {
      token?: string;
      login_session_id?: number | string | null;
      src?: string;
      /** For IDLE_3HR: last-activity + 3h (caps sleep/wake durations). */
      logout_at?: string;
    }
  ) {
    const type = this.normalizeLogoutType(logout_type);
    let login_session_id: number | null = null;
    let storedSrc = '';
    let profileToken = profile?.token || '';
    let logoutAt = profile?.logout_at || '';
    try {
      if (profile) {
        const sid = profile.login_session_id;
        if (sid) {
          login_session_id = Number(sid);
        }
        storedSrc = profile.src || '';
      } else {
        const cu = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const sid = cu?.v1_data?.login_session_id;
        if (sid) {
          login_session_id = Number(sid);
        }
        storedSrc = cu?.v1_data?.src || '';
      }
    } catch {
      login_session_id = null;
    }
    const user_agent =
      typeof navigator !== 'undefined' && navigator.userAgent
        ? navigator.userAgent
        : '';
    const body: any = {
      logout_type: type,
      login_session_id,
      user_agent,
      src: this.normalizeLoginSrc(storedSrc || this.getLoginSrc()),
    };
    if (type === 'IDLE_3HR' && logoutAt) {
      body.logout_at = logoutAt;
    }
    if (profileToken) {
      return this.http.post<any>(this.apiUrl + '/auth1/logout', body, {
        headers: new HttpHeaders({ Authtoken: `Bearer ${profileToken}` }),
      });
    }
    return this.http.post<any>(this.apiUrl + '/auth1/logout', body);
  }

  /**
   * MANUAL — user clicked Logout.
   * ACCOUNT_SWITCH — previous alias closed during switch.
   * TOKEN_FAIL — auth refresh failed.
   * IDLE_3HR — default for idle / any other session close.
   */
  normalizeLogoutType(logout_type?: string | null): string {
    const t = String(logout_type || '').trim().toUpperCase();
    if (t === 'MANUAL') {
      return 'MANUAL';
    }
    if (t === 'TOKEN_FAIL') {
      return 'TOKEN_FAIL';
    }
    if (t === 'ACCOUNT_SWITCH') {
      return 'ACCOUNT_SWITCH';
    }
    return 'IDLE_3HR';
  }

list_customer(params='') {
    return this.http
    .get<any>(this.RapiUrl + '/customer/list?'+params).pipe(
    map(res => res));
  }

  customergrouplist(params='') {
    return this.http
    .get<any>(this.RapiUrl + '/customer/customergrouplist?'+params).pipe(
    map(res => res));
  }


  search_customer(term : any='0') {
    return this.http
    .get<any>(this.RapiUrl + '/customer/search?q='+term).pipe(
    map(res => res));
  }

 addeditcustomer(customer) {  
    return this.http.post(this.apiUrl + '/customer/addeditcustomer',customer).pipe(
    map(res => res));
  }

  addeditcustomergroup(customer) { 
   
    return this.http.post(this.apiUrl + '/customer/addeditcustomergroup',customer).pipe(
    map(res => res));
  }


  //Dashboard Service

  listdefaulters(params='') {
    return this.http
    .get<any>(this.RapiUrl + '/dashboard/listdefaulters?'+params).pipe(
    map(res => res));
  }

  //Document Service

  getConfig_document(){
    const  treeConfig: any = {
        baseURL: this.apiUrl+'/document',
        api: {
          listFile: '/list',
          uploadFile: '/upload',
          downloadFile: '/download',
          deleteFile: '/remove',
          createFolder: '/directory',
          renameFile: '/rename',
          searchFiles: '/search'
        },
        options: {
          allowFolderDownload: false,
          showFilesInsideTree: false
        }
      }; 

      return treeConfig;
}


list_document(params='') {
    
  return this.http
  .get<any>( this.RapiUrl + '/document/list/?'+params).pipe(
  map(res => res));

}

delete_document(params='') {
    
  return this.http
  .get<any>( this.apiUrl + '/document/delete/?'+params).pipe(
  map(res => res));

}

addEdit_document(role) {
  console.log(role);
     return this.http.post(this.apiUrl + '/document/addedit',role).pipe(
     map(res => res));
 }


 uploadfile_document(file, description) {
  let formData: FormData = new FormData();
  formData.append('file', file, file.name);
  formData.append('description', description);

  return this.http.post<any>(this.apiUrl + '/document/uploadfile', formData).pipe(
  map(upost => {
      // login successful if there's a jwt token in the response
     
       return upost;
  }));
}
 uploadfileimg_document(file, description) {
  let formData: FormData = new FormData();
  formData.append('file', file, file.name);
  formData.append('description', description);

  return this.http.post<any>(this.apiUrl + '/document/uploadfileimg', formData).pipe(
  map(upost => {
      // login successful if there's a jwt token in the response
     
       return upost;
  }));
}

// Upload evidence
uploadEvidencefile_document(file) {
  let formData: FormData = new FormData();
  for (var i = 0; i < file.length; i++) { 
    formData.append('file[]', file[i], file[i].name);
  }

  // return this.http.post<any>(this.apiUrl + '/document/uploadEvidence', formData).pipe(
  // map(upost => {
  //     // login successful if there's a jwt token in the response
     
  //      return upost;
  // }));

  return this.http.post(this.apiUrl + '/document/uploadEvidence', formData, {
    reportProgress: true,
    observe: 'events'
  }).pipe(map(res=>{
    console.log("file result",res);
    return res;
  }))
}

//einvoice ct service


list_einvoicect(params = '') {

  return this.http
    .get<any>(this.RapiUrl + '/Einvoicect/list?' + params).pipe(
      map(res => res));

}

//invoice Service

list_invoice() {
  return this.http
  .get<any>(this.apiUrl + '/invoice/list').pipe(
  map(res => res));
}

//lead service

list_lead(params = '') {

  return this.http
    .get<any>(this.RapiUrl + '/lead/list?' + params).pipe(
      map(res => res));

}

leadsearch(params = '') {

  return this.http
    .get<any>(this.RapiUrl + '/lead/leadsearch?' + params).pipe(
      map(res => res));

}
// lead ques.
leadstatusdata(params = '') {

  return this.http
    .get<any>(this.RapiUrl + '/lead/leadstatusdata?' + params).pipe(
      map(res => res));
}



//lead status service

list_leadstatus(params='') {
        
  return this.http
  .get<any>( this.RapiUrl + '/leadstatus/list?'+params).pipe(
  map(res => res));

}

listQuestions_leadstatus(params='') {
  
  return this.http
  .get<any>( this.RapiUrl + '/leadstatus/questions?'+params).pipe(
  map(res => res));

}

addEdit_leadstatus(role) {
  console.log(role);
     return this.http.post(this.apiUrl + '/leadstatus/addedit',role).pipe(
     map(res => res));
 }

 addEditLeadStatusQuestion(role) {
  console.log(role);
     return this.http.post(this.apiUrl + '/leadstatus/addeditleadstatusquestion',role).pipe(
     map(res => res));
 }


 //LicenseCategory Service


 list_licensecategory() {
  return this.http
  .get<any>(this.R2apiUrl + '/licensecategory/list').pipe(
  map(res => {
      //   console.log(quotation);
          localStorage.setItem('lcs',JSON.stringify(res));
          return res;
     }));
}


// Master Service

listcity(params='') {
  return this.http
  .get<any>(this.RapiUrl + '/master/listcity?'+params).pipe(
  map(res => res));
}

downloadMaster(params) {
  return this.http.post<any>(this.apiUrl + '/master/downloadmaster', params).pipe(
    map(res => res));
}

uploadMaster(file, params) {
  const formData = new FormData();
  formData.append('file', file, file.name);
  if (params.master_type) {
    formData.append('master_type', params.master_type);
  }
  if (params.searchqf) {
    formData.append('searchqf', params.searchqf);
  }
  return this.http.post<any>(this.apiUrl + '/master/uploadmaster', formData).pipe(
    map(res => res));
}

listcity_2(params='') {
  return this.http
  .get<any>(this.RapiUrl + '/master/listcity_2?'+params).pipe(
  map(res => res));
}

listmetamaster(params='') {
  return this.http
  .get<any>(this.RapiUrl + '/master/listmetamaster?'+params).pipe(
  map(res => res));
}

listregion(params='') {
  return this.http
  .get<any>(this.RapiUrl + '/master/listregion?'+params).pipe(
  map(res => res));
}

listmetatypes(params='') {
  return this.http
  .get<any>(this.RapiUrl + '/master/listmetatypes?'+params).pipe(
  map(res => res));
}

listeventvenuetag(params='') {
  return this.http
  .get<any>(this.RapiUrl + '/master/listeventvenuetag?'+params).pipe(
  map(res => res));
}


citysearch(term : any='0') {
  return this.http
  .get<any>(this.RapiUrl + '/master/citysearch?q='+term).pipe(
  map(res => res));
}

citysearch_2(term : any='0') {
  return this.http
  .get<any>(this.RapiUrl + '/master/citysearch_2?q='+term).pipe(
  map(res => res));
}

metasearch(term : any='0',type:any='') {
  term=encodeURIComponent(term);
  type=encodeURI(type);
  return this.http
  .get<any>(this.R2apiUrl + '/master/metasearch?q='+term+'&type='+type).pipe(
  map(res => res));
}

addeditcity(customer) {  
  return this.http.post(this.apiUrl + '/master/addeditcity',customer).pipe(
  map(res => res));
}

addeditcity_2(customer) {  
  return this.http.post(this.apiUrl + '/master/addeditcity_2',customer).pipe(
  map(res => res));
}
addeditmetamaster(customer) {  
  return this.http.post(this.apiUrl + '/master/addeditmetamaster',customer).pipe(
  map(res => res));
}

addeditregion(region) {
  return this.http.post(this.apiUrl + '/master/addeditregion', region).pipe(
  map(res => res));
}

deletecity(params='') {
  
  return this.http
  .get<any>( this.apiUrl + '/master/deletecity/?'+params).pipe(
  map(res => res));

}

deletecity_2(params='') {
  
  return this.http
  .get<any>( this.apiUrl + '/master/deletecity_2/?'+params).pipe(
  map(res => res));

}

deletemetamaster(params='') {
  
  return this.http
  .get<any>( this.apiUrl + '/master/deletemetamaster/?'+params).pipe(
  map(res => res));

}

deleteregion(params='') {

  return this.http
  .get<any>( this.apiUrl + '/master/deleteregion/?'+params).pipe(
  map(res => res));

}

searcheventname(term : any='') {
  console.log("event name", term);
  return this.http
  .get<any>(this.RapiUrl + '/Quotation/EventnameSearch?q='+term).pipe(
  map(res => res));
}

// Advocate Master Service

listadvocate(params = '') {
  return this.http
    .get<any>(this.V2apiUrl + '/items/advocate_master?' + params).pipe(
    map(res => res));
}

addeditadvocate(model: any) {
  if (model.id) {
    return this.http.patch<any>(this.V2apiUrl + '/items/advocate_master/' + model.id, model).pipe(
      map(res => res));
  }
  return this.http.post<any>(this.V2apiUrl + '/items/advocate_master', model).pipe(
    map(res => res));
}

deleteadvocate(id: any) {
  return this.http.delete<any>(this.V2apiUrl + '/items/advocate_master/' + id).pipe(
    map(res => res));
}



//Quotation Service

list_quotation(params = '') {

  return this.http
    .get<any>(this.RapiUrl + '/quotation/list?' + params).pipe(
      map(res => res));

}

creditnotelist(params = '') {

  return this.http
    .get<any>(this.RapiUrl + '/creditnote/list?' + params).pipe(
      map(res => res));

}


licenselist(params = '') {

  return this.http
    .get<any>(this.RapiUrl + '/quotation/licenselist?' + params).pipe(
      map(res => res));

}

Rlist(params = '') {
  return this.http
    .get<any>(this.RapiUrl + '/quotation/list?' + params).pipe(
      map(res => res));
}

getreportlist(params = '') {
  return this.http
    .get<any>(this.RapiUrl + '/report/list').pipe(
      map(res => res));
}


getSingle(id,uuid) {
  console.log(id,uuid,' get single id and uuid');
  return this.http
    .get<any>(this.apiUrl + '/quotation/single?id=' + id).pipe(
      map(res => res));
}

getPincodeinfo(id) {
  return this.http
    .get<any>(this.RapiUrl + '/quotation/pincodeinfo?pincode=' + id).pipe(
      map(res => res));
}

addSave_quotation($debug) {
  //        console.log(JSON.stringify($debug));

  return this.http.post<any>(this.apiUrl + '/quotation/addsave', $debug).pipe(
    map(quotation => {
      //   console.log(quotation);
      return quotation;
    }));
}

addSaveIssuedLc(ilc: any) {

  //console.log(ilc);    
  return this.http.post<any>(this.apiUrl + '/quotation/addsaveissuedlc', ilc).pipe(
    map(quotation => {
      //   console.log(quotation);
      return quotation;
    }));
}


addSaveDiscountRequest(ilc: any) {

  console.log(ilc);
  return this.http.post<any>(this.apiUrl + '/quotation/addsavediscountrequest', ilc).pipe(
    map(quotation => {
      //   console.log(quotation);
      return quotation;
    }));
}

addSaveRequest(ilc: any) {

  console.log(ilc);
  return this.http.post<any>(this.apiUrl + '/quotation/addsaverequest', ilc).pipe(
    map(quotation => {
      //   console.log(quotation);
      return quotation;
    }));
}

addSaveAtiRequest(ilc: any) {

  console.log(ilc);
  return this.http.post<any>(this.apiUrl + '/quotation/addsaveatirequest', ilc).pipe(
    map(quotation => {
      //   console.log(quotation);
      return quotation;
    }));
}

addSavePitagRequest(ilc: any) {

  console.log(ilc);
  return this.http.post<any>(this.apiUrl + '/quotation/addsavetagpi', ilc).pipe(
    map(quotation => {
      //   console.log(quotation);
      return quotation;
    }));
}

//  Request for PI
AddSavePIRequest(ilc: any) {

  console.log(ilc);
  return this.http.post<any>(this.apiUrl + '/quotation/AddSavePIRequest', ilc).pipe(
    map(quotation => {
      //   console.log(quotation);
      return quotation;
    }));
}

venuesearch(term: any = '0') {
  return this.http
    .get<any>(this.RapiUrl + '/quotation/venuesearch?q=' + term).pipe(
      map(res => res));
}





uploadfileandrunbu(file) {
  let formData: FormData = new FormData();
  formData.append('file', file, file.name);

  return this.http.post<any>(this.apiUrl + '/quotation/bulkimportfilecsvtojson', formData).pipe(
    map(upostn => {
      // login successful if there's a jwt token in the response

      return upostn;
    }));
}

// genrate sos tax invoice number
genratesosinvoice(ilc: any){

  console.log(ilc);
  return this.http.post<any>(this.apiUrl + '/quotation/genrate_sos_invoice', ilc).pipe(
    map(quotation => {
      //   console.log(quotation);
      return quotation;
    }));
}

addeditsoscustomer(customer) {  
  return this.http.post(this.apiUrl + '/customer/addeditsoscustomer',customer).pipe(
  map(res => res));
}

genReport(params) {
  // return this.http
  // .get<any>(this.apiUrl + '/report/genreport?'+params).pipe(
  // map(res => res));

  return this.http.post<any>(this.R2apiUrl + '/report/genreport', params).pipe(
    map(upostn => {
      // login successful if there's a jwt token in the response

      return upostn;
    }));

}

getDashboarddata(params = '') {
  return this.http
    .get<any>(this.RapiUrl + '/report/dashboarddata?' + params).pipe(
      map(res => res));
}

genGststatecodes(params = '') {
  return this.http
    .get<any>(this.RapiUrl + '/quotation/gststatecodes').pipe(
      map(res => res));
}

markCancel(id) {
  return this.http
    .get<any>(this.apiUrl + '/quotation/markcancel/?id=' + id).pipe(
      map(res => res));
}

creditnotebyquotation(id){

  return this.http
    .get<any>(this.apiUrl + '/quotation/CreditNotesByQuotationId/?id=' + id).pipe(
      map(res => res));

}

quotationsendalert(param) {
  return this.http.post<any>(this.apiUrl + '/quotation/sendalert', param).pipe(
    map(res => {
      return res;
    }));
}


recreateLicenses(quotation_id) {
// console.log('id', quotation_id);
  return this.http.post<any>(this.apiUrl + '/quotation/resetlicenses', { id: quotation_id}).pipe(
    map(res => {
      return res;
    }));
}

licensedwllist(params = '') {
  return this.http
    .get<any>(this.RapiUrl + '/quotation/DownloadLicenseList?' + params).pipe(
      map(res => res));
}

addSaveEvidence($debug){
  //        console.log(JSON.stringify($debug));

  return this.http.post<any>(this.apiUrl + '/quotation/addSaveEvidence', $debug).pipe(
    map(quotation => {
      //   console.log(quotation);
      return quotation;
    }));
}

// createrenewalpi api call
// createrenewalpi($debug) {
//   console.log('create renewal pi', $debug);
//   return this.http.post<any>(this.apiUrl + '/quotation/renewalpi', $debug).pipe(
//     map(q => {
//       return q;
//     }));
// }

cancelInvoice(quotation_id) {
  return this.http.post<any>(this.apiUrl + '/einvoicect/Cancelinvoice', { id: quotation_id}).pipe(
    map(res => {
      return res;
    }));

  
}

// Add Save customer no pan Request

addSaveCpnRequest(ilc: any) {

  console.log(ilc);
  return this.http.post<any>(this.apiUrl + '/quotation/AddSavecustomernopanRequest', ilc).pipe(
    map(quotation => {
      //   console.log(quotation);
      return quotation;
    }));
}

 //role service


 list_role() {
  return this.http
  .get<any>(this.apiUrl + '/role/list').pipe(
  map(res => res));
}

listPermissions(){
  return this.http
  .get<any>(this.apiUrl + '/role/listpermissions').pipe(
  map(res => res));
}  

 addEdit_role(role) {
  console.log(role);
     return this.http.post(this.apiUrl + '/role/addedit',role).pipe(
     map(res => res));
 }

 search_role(term : any='0') {
  return this.http
  .get<any>(this.apiUrl + '/role/search?q='+term).pipe(
  map(res => res));
}


//Setting Service

list_setting() {
  return this.http
  .get<any>(this.apiUrl + '/setting/list').pipe(
  map(res => res));
}

//Target Service

list_target(params='') {
  return this.http
  .get<any>(this.R2apiUrl + '/target/list?'+params).pipe(
  map(res => res));
}
addEdit_target(role) {
  console.log(role);
     return this.http.post(this.apiUrl + '/target/addedit',role).pipe(
     map(res => res));
 }

 resetTargets(role) {
  console.log(role);
     return this.http.post(this.apiUrl + '/target/resettargets',role).pipe(
     map(res => res));
 }


 //Tracking Service

 list_tracking(params:any={}) {
  return this.http

  .get<any>(this.R2apiUrl + '/tracking/trackinglist?',{params:params}).pipe(

  map(res => res));
}

//Transaction nService
windowpopup(path='',width=999,height=700){
  window.open(path, '_blank', 'toolbar=no,scrollbars=yes,resizable=yes,top=50,left=200,width='+width+',height='+height);
}


list_transaction(params='') {
  return this.http
  .get<any>(this.RapiUrl + '/transaction/list?'+params).pipe(
  map(res => res));
}

listreturn_transaction(params='') {
  return this.http
  .get<any>(this.RapiUrl + '/transaction/listreturn?'+params).pipe(
  map(res => res));
}

listbankstatement(params='') {
  return this.http
  .get<any>(this.RapiUrl + '/transaction/listbankstatement?'+params).pipe(
  map(res => res));
}


runreco() {
  return this.http
  .get<any>(this.apiUrl + '/transaction/runreco').pipe(
  map(res => res));
}


addedit_transaction(r:any) {
    console.log(r);
  return this.http.post<any>(this.apiUrl + '/transaction/addedittransaction', r).pipe(
      map(user => {
           console.log(user);
           return user;
      }));
}

addeditreturn_transaction(r:any) {
//      console.log(r);
return this.http.post<any>(this.apiUrl + '/transaction/addeditreturntransaction', r).pipe(
  map(user => {
       
       return user;
  }));
}


addEditCreditNote(r:any) {
//      console.log(r);
    return this.http.post<any>(this.apiUrl + '/transaction/addeditcreditnote', r).pipe(
        map(user => {
             
             return user;
        }));
    }



delete_transaction(r) {
  return this.http.post<any>(this.apiUrl + '/transaction/delete', r).pipe(
  map(user => {
       
       return user;
  }));
}

deletebankstatement(r) {
  return this.http.post<any>(this.apiUrl + '/transaction/deletebankstatement', r).pipe(
  map(user => {
       
       return user;
  }));
}


uploadfileandrunreco(file) {
  let formData: FormData = new FormData();
  formData.append('file', file, file.name);

  return this.http.post<any>(this.apiUrl + '/transaction/uploadfileandrunreco', formData).pipe(
  map(upost => {
      // login successful if there's a jwt token in the response
     
       return upost;
  }));
}

questionuploadfile(file) {
  let formData: FormData = new FormData();
  formData.append('file', file, file.name);

  return this.http.post<any>(this.apiUrl + '/transaction/uploadfilesurvey', formData).pipe(
  map(upost => {
      // login successful if there's a jwt token in the response
     
       return upost;
  }));
}


//user service

list_user(params='') {
    
  return this.http
  .get<any>(this.R2apiUrl + '/user/list?' + params).pipe(
  map(res => {
      //   console.log(quotation);
          sessionStorage.setItem('users',JSON.stringify(res));
          return res;
     }));
}

list_useralias(params='') {
    
  return this.http
  .get<any>(this.R2apiUrl + '/user/listalias?' + params).pipe(
  map(res => {
      //   console.log(quotation);
          //sessionStorage.setItem('users',JSON.stringify(res));
          return res;
     }));
}


 addEdit_user(selectedUser) {
 console.log(selectedUser);
 return this.http.post<any>(this.apiUrl + '/user/addedit',  selectedUser ).pipe(
 map(user => {
  //   console.log(quotation);
      return user;
 }));
}

freezlist(){
  return this.http
  .get<any>(this.R2apiUrl + '/user/userfrzList').pipe(
  map(res => {
      //   console.log(quotation);
          //sessionStorage.setItem('users',JSON.stringify(res));
          return res;
     }));
}

defreezuser(userid) {
  return this.http.post<any>(this.apiUrl + '/user/DefreezUser ',  { id: userid}).pipe(
  map(user => {
   //   console.log(quotation);
       return user;
  }));
 } 

 motherchildregion() {
  return this.http.get<any>(this.R2apiUrl + '/user/motherZones').pipe(
  map(res => res));
}

getchildregion(region) {
    console.log(region);
  return this.http.post<any>(this.R2apiUrl + '/user/ChildZonesByregion', { region: region}).pipe(
  map(res => {
          return res;
     }));
}

checkPermission(pid){
    //get localStorage
    let cuuser=JSON.parse(localStorage.getItem('currentUser') ?? '');
    let cu = cuuser.v1_data;
    //   console.log(pid,cu.role.permissions);
    if(cu.role.allowall_super === '1'){
      return true;
  }
    if(pid==26 && cu.report_access?.length){
      return true;
    }
  if(cu.role.permissions){
      const pus=cu.role.permissions.split(',');
      // console.log(pus,pid.toString(),pus.includes(pid.toString()));
      return pus.includes(pid.toString());
  }

  return true;
}

   // current customer
   setCurrentCustomer(customerData){
    return localStorage.setItem('currentcustomer', JSON.stringify(customerData));
  }
  getCurrentCustomer(){
    const raw = localStorage.getItem('currentcustomer');
    if (!raw) {
      return null;
    }
    try {
      const parsed = JSON.parse(raw);
      // Avoid truthy empty array from legacy fallback JSON.parse('[]')
      if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') {
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  }
  removeCurrentCustomer(){
    localStorage.removeItem('currentcustomer');
  }

  // current customer
  setSearchCustomer(searchCust){
    return localStorage.setItem('searchCustomer', JSON.stringify(searchCust));
  }
  getSearchCustomer(){
    return JSON.parse(localStorage.getItem('searchCustomer') ??'[]');
  }
  removeSearchCustomer(){
    localStorage.removeItem('searchCustomer');
  }

  cloneWR(p) {
    return p ? JSON.parse(JSON.stringify(p)) : '';
  }

  list_noc(params = '') {  
    return this.http.get(this.apiUrl + '/nocfoc/list?'+ params).pipe(
    map(res => res));
  }

  addedit_noc(object) {  
    return this.http.post(this.apiUrl + '/nocfoc/addedit',object).pipe(
    map(res => res));
  }

  getSingle_noc(id) {
    console.log(id,' get single id and uuid');
    return this.http
      .get<any>(this.apiUrl + '/nocfoc/single?id=' + id).pipe(
        map(res => res));
  }

  list_requests(params = '') {  
    return this.http.get(this.apiUrl + '/requests/list?'+ params).pipe(
    map(res => res));
  }
 
   cartlist(params: string = '') {  
    // The API path is /requests/cartlist. The base URL is assumed to be this.apiUrl.
    // The '?' and the parameters string are appended to the path.
    return this.http.get(this.apiUrl + '/requests/cartlist?' + params).pipe(
    map(res => res));
  }


  approveLegalNotice(data: any) {
    const emailDeliveryFailedMessage =
      "Legal Notice approved. Email delivery failed. Please check the customer's email address.";

    return this.http
      .post<any>(this.apiUrl + '/legal/approveNotice', data)
      .pipe(map(res => {
        const mailStatus = res?.mail_status;
        const mailFailed =
          res?.status === 'error' ||
          res?.email_delivery_failed === true ||
          (mailStatus && typeof mailStatus === 'object' && mailStatus.success === false) ||
          (typeof mailStatus === 'string' && /^(error|mailer error):/i.test(mailStatus.trim()));

        if (mailFailed) {
          throw {
            emailDeliveryFailed: true,
            message: res?.message || emailDeliveryFailedMessage,
          };
        }

        return res;
      }));
  }

  // Reject Legal Notice
  rejectLegalNotice(data: any) {
    return this.http
      .post<any>(this.apiUrl + '/legal/rejectNotice', data)
      .pipe(map(res => res));
  }

  
  getLegalNoticesList(params: any) {
    return this.http.get(
      this.apiUrl + '/legal/list',
      { params }
    );
  }

  legal_noticeby_quotation(term : any='0') {
    return this.http
    .get<any>(this.RapiUrl + '/legal/pinotice?id='+term).pipe(
    map(res => res));
  }

  checkLegalNoticeDuplicate(data: any) {
    return this.http.post<any>(this.apiUrl + '/legal/check_duplicate', data).pipe(
      map(res => res)
    );
  }

  // ApiV1Service.ts
  addSaveLegalNoticeEvidence(payload: any) {
 
    return this.http.post<any>(this.apiUrl + '/legal_notice/addSaveEvidence', payload).pipe(
      map(res => {
        console.log('Legal Evidence Saved:', res);
        return res;
      })
    );
  }

  quotation_log_list(term : any='0') {
    return this.http
    .get<any>(this.RapiUrl + '/quotation/log_quotation_event_data?id='+term).pipe(
    map(res => res));
  }
  

  panverification(payload: any) {
 
    return this.http.post<any>(this.apiUrl + '/Verification/pan', payload).pipe(
      map(res => {
        console.log('Legal Evidence Saved:', res);
        return res;
      })
    );
  }

  tanverification(payload: any) {
 
    return this.http.post<any>(this.apiUrl + '/Verification/tan', payload).pipe(
      map(res => {
        console.log('Legal Evidence Saved:', res);
        return res;
      })
    );
  }

  gstverification(payload: any) {
 
    return this.http.post<any>(this.apiUrl + '/Verification/gst', payload).pipe(
      map(res => {
        console.log('Legal Evidence Saved:', res);
        return res;
      })
    );
  }

  legal_send_notification(params:any){

     return this.http.get(
      this.apiUrl + '/legal/send_notification',
      { params }
    );
  }


}
